module.exports = __webpack_public_path__ + "static/media/MENU LOAD.6eff829f.svg";